import React, { useState, useEffect, Fragment } from 'react'
import { useNavigate } from 'react-router'
import { Link } from 'react-router-dom'
import { Row, Form, Table, Card, ButtonGroup, DropdownButton, Button, Col, Badge } from 'react-bootstrap'
import { connect } from 'react-redux';
import store from 'store/store';
import PropagateLoader from "react-spinners/PropagateLoader";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { toast } from 'react-toastify';
import Select from 'react-select';
import { selectBaseStyles, selectInvalidStyles, requiredIndicator, dictionary, fields_array_normalize } from './Config';
import DatePicker from '@amir04lm26/react-modern-calendar-date-picker';

function MyForm2Details(props) {
    const {control, reset, getValues} = props
    const values = getValues()
    
    // useEffect(() => {
        
    // }, [])


    return (
        <Row>
        {
            props?.fields?.filter(item => item.visibility)?.map((item,index) => {
                return (
                    <Fragment key={item.id}>
                        <Form.Group 
                            as={Col} 
                            sm={Array.isArray(item.bs_grid) && item.bs_grid[0]}
                            md={Array.isArray(item.bs_grid) && item.bs_grid[1]}
                            lg={Array.isArray(item.bs_grid) && item.bs_grid[2]}
                            xl={Array.isArray(item.bs_grid) && item.bs_grid[3]}
                            xxl={Array.isArray(item.bs_grid) && item.bs_grid[4]}
                            className={item.className + " text-secondary"}
                        >
                            {
                                (item.name !== null && item.name !== undefined) &&
                                <>
                                {
                                    <>
                                        <Form.Label>
                                            {/* <span>{item.title ? item.title : dictionary?.fields[item.name]}</span> */}
                                            <span>
                                                {
                                                    item.title 
                                                    ? 
                                                    item.title 
                                                    : 
                                                    props?.fields_dic_prefix
                                                        ?
                                                        dictionary.fields[props?.fields_dic_prefix][item.name]
                                                        :
                                                        dictionary.fields[item.name]
                                                }
                                            </span>
                                        </Form.Label>
                                        {
                                            Array.isArray(values[item.name])
                                            ?
                                                item.type === 'file'
                                                ?
                                                    <div className="form-control" dir={item.dir}>
                                                        {values[item.name]?.map((item2, key2) => {
                                                            // return <Badge key={key2} bg="info" className="m-1"><a href={item2.url}>{item2.name}</a></Badge>
                                                            return (
                                                                <Badge bg="light" key={key2} className="m-1" style={{width:'80px'}}>
                                                                    <a href={item2.url} target="_blank"><img style={{width:'100%',height:'auto'}} src={item2.url} /></a>
                                                                </Badge>
                                                            )
                                                        })}
                                                    </div>
                                                :
                                                    <div className="form-control" dir={item.dir}>
                                                        {values[item.name]?.map((item2, key2) => {
                                                            return <Badge key={key2} bg="info" className="m-1">{item2}</Badge>
                                                        })}
                                                    </div> 
                                            :
                                            null
                                        }
                                        {
                                            !Array.isArray(values[item.name]) && item.type === 'textarea' &&
                                                <div className="form-control p-2" dir={item.dir}>
                                                    {values[item.name]?.split('\n').map((item, key) => {
                                                        return <span key={key}>{item}<br/></span>
                                                    })}
                                                </div>
                                        }
                                        {
                                            !Array.isArray(values[item.name]) && item.type === 'TinyCME' &&
                                                <div 
                                                    className="form-control p-2" 
                                                    dir={item.dir} 
                                                    style={{backgroundColor:'#e9ecef', minHeight:'38px', maxHeight:'300px', overflow:'scroll'}} 
                                                    dangerouslySetInnerHTML={{ __html: values[item.name] }}
                                                >
                                                </div>
                                        }
                                        {
                                            !Array.isArray(values[item.name]) && item.type !== 'textarea' && item.type !== 'TinyCME' && item.type !== 'component' &&
                                                <div className="form-control" dir={item.dir} style={{lineHeight:'28px'}}>
                                                    {values[item.name] ? values[item.name] : ''}
                                                </div>
                                        }
                                        {/* {
                                            !Array.isArray(values[item.name]) && item.type === 'component' &&
                                                <div className="m-1">{item.component}</div>
                                        } */}
                                    </>
                                }
                                </>
                            }
                            {
                                item.type === 'component' &&
                                <div className="m-1">{item.component}</div>
                            }
                            {
                                item.type === 'divider' &&
                                <div className="w-100 m-1"></div>
                            }
                        </Form.Group>
                    </Fragment>
                )
            })
        }
        {
            props?.extraComponents 
        }
        </Row>
    )
}


export default MyForm2Details;